<template>

  <popup
    button-style="text"
    :heading="'Details for ' + rowData.name"
    button-text="Charts"
    button-size="mini"
    :show-save="false"
    button-icon="fa fa-chart-pie">

    <el-row :gutter="24">

      <el-col :sm="24" :md="24" :lg="24">
        <div class="dash-heading">{{rowData.name}}</div>
      </el-col>

      <el-col :sm="24" :md="24" :lg="24">
        <op-stats :stats="rowData" :org-id="rowData.organisation_id" />
        <br />
      </el-col>

      <el-col v-if="hasSites" :sm="24" :md="12" :lg="hasRequests ? 10 :  24">
        <el-card shadow="hover">
          <template #header><div class="clearfix">
            <span class="text-primary"><i class="fa fa-broadcast-tower" />&nbsp;Sites</span>
          </div></template>

          <sites-chart :stats="rowData" :slices="siteSlices" />

        </el-card>

      </el-col>


      <el-col v-if="hasRequests" :sm="24" :md="12" :lg="hasSites ? 14 :  24">
        <el-card shadow="hover">
          <template #header><div class="clearfix">
            <span class="text-success"><i class="fa fa-share-alt" />&nbsp;Requests</span>
          </div></template>

          <requests-chart :stats="rowData" />
        </el-card>

      </el-col>



    </el-row>

  </popup>

</template>



<script>

import SitesChart from '@/components/dashboard/charts/SitesChart'
import RequestsChart from '@/components/dashboard/charts/RequestsChart'

import OpStats from '@/components/dashboard/OpStats'

// XOL-696: the Sites pie shows the Sharers Summary's own statuses, in the table's order and
// coloured like its column headers (no Land Only, no Sold). Static config, not store-derived.
// Frozen so Vue does not make the shared module array reactive.
var SITE_SLICES = Object.freeze([
  Object.freeze({ key: 'sitesActive', label: 'Active', color: '#409EFF' }),
  Object.freeze({ key: 'sitesNew', label: 'New', color: '#67C23A' }),
  Object.freeze({ key: 'sitesExclusive', label: 'Exclusive', color: '#303133' }),
  Object.freeze({ key: 'sitesCandidate', label: 'Candidate', color: '#E6A23C' }),
  Object.freeze({ key: 'sitesTemporary', label: 'Temporary', color: '#909399' }),
  Object.freeze({ key: 'sitesDismantled', label: 'Dismantled', color: '#F56C6C' })
])

export default {

  props: {

    rowData: {
      type: Object,
      required: true
    }

  },

  components: {
    SitesChart,
    RequestsChart,
    OpStats
  },

  data () {
    return {
      siteSlices: SITE_SLICES
    }
  },

  computed: {

    // XOL-696: the card shows when any of the six charted statuses is above 0, derived from the
    // slice set so the two cannot drift. A telco whose only sites are terminated Dismantled ones
    // has Total 0 but a pie to show; one whose only sites are Land Only or Sold has Total > 0 and
    // an empty pie, so no card.
    hasSites: function () {
      var row = this.rowData
      return SITE_SLICES.some(function (sl) { return row[sl.key] > 0 })
    },

    hasRequests: function () {
      return this.rowData.rta > 0 || this.rowData.rts > 0 || this.rowData.rtu > 0 || this.rowData.rtb > 0 || this.rowData.rtd > 0
    },

    hasTickets: function () {
      return this.rowData.tickets > 0
    }

  },
/*
  created () {
    console.log('PSS rowData', this.rowData)
  }
*/
}

</script>
